module.exports = __webpack_public_path__ + "img/image22.50980b01.png";